<script>
  export default {
    props: {
      freeShipping: {
        type: Boolean,
        default: false
      },
      isExamenBuddy: {
        type: Boolean,
        default: false
      },
      isSmall: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<template>
  <p
    class="text-blue-600"
    :class="isSmall ? 'text-xs leading-none' : 'text-base leading-relaxed '"
  >
    <span class="font-bold">
      Gratis
    </span>
    {{ isExamenBuddy ? 'verzonden, vandaag in je mailbox' : 'verzonden vanaf 25 euro' }}
  </p>
</template>
